<script>
export default {
  name: 'FormItemsInForm',
  methods: {
    formPrefilledResponseNameFormItems () {
      const formItems = [
        { name: 'Date', tag: 'date', static: true },
        { name: 'Time', tag: 'time', static: true },
        { name: 'Date & Time', tag: 'datetime', static: true },
        { name: 'Counter', tag: 'counter', static: true },
        { name: 'Member Tag', tag: 'member_reference_code', static: true }
      ]
      return formItems.concat(this.allFormItems())
    },
    allFormItems (fieldTypes, cb, upto, sectionId) {
      const formItems = []
      if (typeof fieldTypes === 'undefined') {
        fieldTypes = null
      }
      if (typeof upto === 'undefined') {
        upto = null
      }
      if (typeof sectionId === 'undefined') {
        sectionId = null
      }
      let shouldbreak = false
      for (const section in this.form.form_sections) {
        if (sectionId !== null && this.form.form_sections[section].form_section_id !== sectionId) {
          continue
        }
        if (shouldbreak) break
        for (const formItem in this.form.form_sections[section].form_items) {
          const fi = this.form.form_sections[section].form_items[formItem]
          if (typeof fi !== 'undefined' && fi.form_item_id === upto) {
            shouldbreak = true
            break
          }
          if (typeof fi !== 'undefined' && fi.name !== null && (fieldTypes === null || (fieldTypes === -1 && !['signature', 'comments_images', 'image', 'comment', 'document', 'note', 'horizontal_separator', 'finish_button'].includes(fi.field_type)) || fieldTypes.includes(fi.field_type))) {
            formItems[formItems.length] = typeof cb === 'function' ? cb(fi) : { name: fi.name, label: fi.name, tag: 'fi:' + fi.form_item_id, id: fi.form_item_id, fid: fi.form_item_id, type: fi.field_type, active: fi.active, section_id: fi.form_section_id, section_name: this.form.form_sections[section].name, pos: fi.pos, options: fi.options_json }
          }
        }
      }
      return formItems
    },
    formItemFromId (id, formItems) {
      if (typeof id === 'string' && id.startsWith('{fi:')) {
        id = id.replace('{fi:', '').replace('}', '')
        if (/^[0-9]+$/.test(id)) {
          id = parseInt(id)
        }
      }

      if (formItems) {
        return formItems.find(formItem => formItem.form_item_id === id)
      }

      for (const section of this.form.form_sections) {
        for (const formItem of section.form_items) {
          if (formItem.form_item_id === id) {
            return formItem
          }
        }
      }
      return null
    },
    formItemNameFromId (id, includeSectionName, formItems) {
      const formItem = this.formItemFromId(id, formItems)

      if (formItem && formItem.name !== null) {
        return formItem.name + (includeSectionName ? ' [' + (formItem.page_name || formItem.section_name) + ']' : '')
      }
      return 'Unknown component'
    }
  }
}
</script>
